import {
  EsignError,
  QuestionsChallengeAction,
  QuestionsChallengeActionError,
} from "@interfaces/Esign";
import { AxiosError } from "axios";
import { getQuestionsChallengeErrorDisplay } from "../constants/questionsChallengeErrorMessages";

export interface ErrorType extends AxiosError {
  error: {
    name: string;
    message: string;
    code?: string;
    action?: QuestionsChallengeAction;
  };
  message: string;
}

export const onQuestionChallengeAxiosErrorInterpreter = (
  error: AxiosError<ErrorType>,
) => {
  const status = error.response?.status;
  const errorData = error.response?.data?.error;
  const nameKey = errorData?.name;
  const message = error.response?.data?.message ?? errorData?.message;
  const action = errorData?.action;
  const code = errorData?.code;

  console.error("Error when generating questions challenges:", {
    status,
    name: nameKey,
    message,
    action,
  });

  if (action) {
    const { name: displayName, description: displayDescription } =
      getQuestionsChallengeErrorDisplay(nameKey);
    throw new QuestionsChallengeActionError(
      message ?? "",
      displayName,
      action,
      displayDescription,
      code,
    );
  }

  if (nameKey === "EsignError") {
    throw new EsignError(message ?? "");
  }
  throw error;
};
